import Mutations from '../../odata/mutations';

export default { ...new Mutations('contract'), ...new Mutations('contracts') };
